import React from "react";
import { TableLoader } from "../../components/loader/Resusable/Table"; //"../loader/Resusable/Table";
import noData from "../../../assets/img/no-data.png";
import { PartnerRow } from "./partnerRow";

export const LandingPageListComponent = ({
  partners,
  isFilterApplied,
  isLoading,
  onEdit,
  onDelete,
  fetchPartnersRecords,
  setFilter,
  sortBy,
  order,
  userDetail,
}) => {
  return (
    <div className="card-body card-table">
      <div className="table-responsive fixed-height-table-10-xs">
        {isLoading ? (
          <TableLoader columns={6} rows={10} />
        ) : (
          <>
            {userDetail && userDetail == "Web" ? (
              <table width="100%" cellSpacing="0">
                <thead className="pad-top">
                  <tr>
                    <th>Logo </th>
                    <th style={{ width: "auto" }}>
                      Partner Name{" "}
                      <span className={"cursor-pointer"}>
                        <span
                          className={`th-up ${
                            order === "asc" && sortBy === "name"
                              ? "active-ac"
                              : ""
                          }`}
                          onClick={() => setFilter("name", "asc")}
                        >
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={`th-down ${
                            order === "desc" && sortBy === "name"
                              ? "active-ac"
                              : ""
                          }`}
                          onClick={() => setFilter("name", "desc")}
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </span>{" "}
                    </th>
                    <th style={{ width: "auto" }}>
                      Email{" "}
                      <span className={"cursor-pointer"}>
                        <span
                          className={`th-up ${
                            order === "asc" && sortBy === "email"
                              ? "active-ac"
                              : ""
                          }`}
                          onClick={() => setFilter("email", "asc")}
                        >
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={`th-down ${
                            order === "desc" && sortBy === "email"
                              ? "active-ac"
                              : ""
                          }`}
                          onClick={() => setFilter("email", "desc")}
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </span>
                    </th>
                    <th style={{ width: "auto" }}>
                      Address{" "}
                      <span className={"cursor-pointer"}>
                        <span
                          className={`th-up ${
                            order === "asc" && sortBy === "country"
                              ? "active-ac"
                              : ""
                          }`}
                          onClick={() => setFilter("country", "asc")}
                        >
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={`th-down ${
                            order === "desc" && sortBy === "country"
                              ? "active-ac"
                              : ""
                          }`}
                          onClick={() => setFilter("country", "desc")}
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </span>{" "}
                    </th>

                    <th
                      style={{
                        width: "190px",
                        // width: "160px",
                        // paddingRight: "20%",
                        // display: "flex",
                        // justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          width: "160px",
                          // paddingRight: "20%",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        Action
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {partners && partners.length ? (
                    partners.map((partner, index) => (
                      <PartnerRow
                        key={index}
                        partnerData={partner}
                        fetchPartnersRecords={fetchPartnersRecords}
                        onEdit={() => onEdit(partner)}
                        onDelete={() => onDelete(partner._id)}
                      />
                    ))
                  ) : (
                    <tr className="no-tr">
                      <td
                        colSpan={5}
                        className={"text-center image-no-data-xs"}
                      >
                        {isFilterApplied ? (
                          <img src={noData} alt="" />
                        ) : (
                          <img src={noData} alt="" />
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              ""
            )}
          </>
        )}
        {/* {!isLoading && totalRecords > limit ? (
          <div className='float-right mt-2'>
            <Pagination
              totalRecords={totalRecords}
              currentPage={currentPage}
              pageLimit={limit}
              onPageChanged={onPageChanged}
            />
          </div>
        ) : null} */}
      </div>
    </div>
  );
};
